import { useQuery } from '@tanstack/react-query';
import NextLink from 'next/link';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import { toStoreOffersLink } from 'lib/links';

import { getCouponFeaturedStoresList } from 'services/coupon';

const FALLBACK_STORES = [
  { storeName: 'KaBuM!', storeSlug: 'kabum' },
  { storeName: 'Magazine Luiza', storeSlug: 'magazine-luiza' },
  { storeName: 'Dafiti', storeSlug: 'dafiti' },
  { storeName: 'Nike', storeSlug: 'nike' },
  { storeName: 'Centauro', storeSlug: 'centauro' },
  { storeName: 'AliExpress', storeSlug: 'aliexpress' },
  { storeName: 'Shopee', storeSlug: 'shopee' },
  { storeName: 'Hering Outlet', storeSlug: 'hering-outlet' },
  { storeName: 'Chico Rei', storeSlug: 'chico-rei' },
];

const FeaturedStores = ({ initialStores = [] }) => {
  const { data: stores = FALLBACK_STORES } = useQuery({
    queryKey: ['coupon', 'featuredStores'],
    queryFn: getCouponFeaturedStoresList,
    initialData: initialStores.length > 0 ? initialStores : undefined,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    select: (data) =>
      Array.isArray(data) && data.length > 0 ? data : FALLBACK_STORES,
  });

  return (
    <Box className="rounded-4 p-4 dark:bg-neutral-low-400">
      <Heading as="h2" className="mb-1 font-medium lg:text-base" size="size6">
        Lojas em destaque
      </Heading>
      <Text className="mb-3 text-xs text-neutral-high-500" size="size2">
        As melhores, classificadas pela comunidade
      </Text>
      <div className="flex flex-wrap gap-2">
        {stores.map(({ storeName, storeSlug }) => (
          <NextLink
            key={storeSlug}
            href={toStoreOffersLink(storeSlug)}
            passHref
          >
            <a className="rounded-4 border border-solid border-neutral-high-300 px-2 py-1 text-sm text-neutral-low-400 transition-colors hover:border-primary-300 hover:text-primary-500 dark:border-neutral-low-300 dark:text-neutral-high-200">
              {storeName}
            </a>
          </NextLink>
        ))}
      </div>
    </Box>
  );
};

export default FeaturedStores;
